<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden" [ngStyle]="backgroundStyle"
  style="min-height: 100vh; min-width: 100vw;">
    <section class="login">
        <div class="container-login">
            <div class="login-card  auth-body">
                <form 
                    class="md-float-material" 
                    (ngSubmit)="submitResetpass(formResetpass)" #formResetpass="ngForm"
                    novalidate>
                    <div class="text-center">
                        <img src="../assets/images/logo_login.png" alt="logo.png">
                    </div>
                    <div class="auth-box">
                        <div class="row m-b-20">
                            <div class="col-md-12">
                                <h3 class="text-left txt-primary">Restablecer Contraseña</h3>
                            </div>
                        </div>
                        <hr />
                        <div class="input-group">
                            <input 
                                type="text" 
                                class="form-control" 
                                (paste)="$event.preventDefault()"
                                placeholder='Usuario' 
                                name="Login"
                                [(ngModel)]="resetpassForm.Login">
                            <span class="md-line"></span>
                        </div>
                        <div class="row m-t-30">
                            <div class="col-md-6">
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                    (click)="cancelar()"
                                >
                                    Cancelar
                                </button>
                            </div>
                            <div class="col-md-6">
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                >
                                    Restablecer
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="text-right" id="divVersionId">
                    </div>
                </form>
            </div>
        </div>
    </section>
</div>